// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"legacy-modal-body_component_modalBody__2P4CG","bodyLayout":"legacy-modal-body_component_bodyLayout__yxQXQ"};